export const categories = [
  {
    name: "Wedding Planners",
    slug: "wedding-planners",
    description: "Professional planners to orchestrate your perfect day"
  },
  {
    name: "Photographers",
    slug: "photographers",
    description: "Capture every magical moment"
  },
  {
    name: "Videographers",
    slug: "videographers",
    description: "Create lasting memories in motion"
  },
  {
    name: "Florists",
    slug: "florists",
    description: "Beautiful floral arrangements for your special day"
  },
  {
    name: "Caterers",
    slug: "caterers",
    description: "Delicious cuisine for your reception"
  },
  {
    name: "Venues",
    slug: "venues",
    description: "Perfect locations for your ceremony and reception"
  },
  {
    name: "DJs & Bands",
    slug: "djs-and-bands",
    description: "Entertainment to keep the party going"
  },
  {
    name: "Cake Designers",
    slug: "cake-designers",
    description: "Beautiful and delicious wedding cakes"
  },
  {
    name: "Bridal Shops",
    slug: "bridal-shops",
    description: "Find your perfect wedding dress"
  },
  {
    name: "Makeup Artists",
    slug: "makeup-artists",
    description: "Professional makeup services for your special day"
  },
  {
    name: "Hair Stylists",
    slug: "hair-stylists",
    description: "Expert hair styling for the wedding party"
  }
];